const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "background.default",
        width: "100%",
    },
    innerBox: {
        p: 3,
        width: "1300px",
        textAlign: "left",
    },
    textFieldContainer: {
        display: "flex",
        gap: 2,
        my: 3,
    },
    footNotes: {
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "166%",
        letterSpacing: "0.4px",
        opacity: 0.5,
        mb: "16px",
    },
    formControlLabel: {
        paddingBottom: "20px",
        fontSize: "16px",
        fontWeight: 500,
        lineHeight: 1.5 /* 24px */,
        letterSpacing: "0.15px",
    },
    buttonContainer: {
        display: "flex",
        gap: 2,
        mt: "32px",
    },
    boldText: {
        fontWeight: 700,
    },
    multilineTextFields: {
        mt: 3,
        width: "50%",
    },
    uploadBtn: {
        mt: 1,
        mb: 1,
    },
    fullHeight: {
        minHeight: `calc(100vh - 310px)`,
    },
    errorText: {
        fontWeight: 400,
        fontSize: "12px",
        color: "im_red.500",
    },
    Text13: {
        fontWeight: 400,
        fontSize: "13px",
    },
    marginBottomBreak: {
        mb: "16px",
    },
    sectionTitle: {
        my: "16px",
    },
    clearIcon: {
        color: "im_mid_blue.500",
    },
    mainWrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "20px",
        pb: "20px",
    },
    div4: {
        width: "auto",
        gridColumnStart: 1,
    },
    statisticWrapper: {
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: "20px",
        mb: "20px",
    },
    formHelperText: {
        my: "20px",
    },
    infoMessagesSection: {
        mb: "20px",
        fontWeight: 500,
    },
    buttonSubmit: {
        paddingLeft: "12px",
        paddingRight: "12px",
    },
};

export default styles;
